import PeriodType from '@/models/enums/statistics/PeriodType'
import { formatNumAsString } from '@/util/num-format'

export function createTooltip (chart) {
  let tooltipEl = chart.canvas.parentNode.querySelector('div')

  if (!tooltipEl) {
    tooltipEl = document.createElement('div')
    tooltipEl.classList.add('tooltip')
    tooltipEl.style.position = 'absolute'
    tooltipEl.style.display = 'flex'
    tooltipEl.style.alignItems = 'center'
    tooltipEl.style.background = '#333232'
    tooltipEl.style.borderRadius = '5px'
    tooltipEl.style.color = 'white'
    tooltipEl.style.opacity = 1
    tooltipEl.style.pointerEvents = 'none'
    tooltipEl.style.position = 'absolute'
    // tooltipEl.style.transform = 'translate(-50%, 0)'
    tooltipEl.style.transition = 'all .1s ease'

    chart.canvas.parentNode.appendChild(tooltipEl)
  }

  return tooltipEl
}

export function createLeftPart (periodType, data) {
  const part = document.createElement('div')
  part.style.padding = '5px 0px 5px 10px'
  part.style.borderRight = '2px solid #7E7E7E'

  switch (periodType) {
    case PeriodType.Week: part.appendChild(createWeekPeriodBlock(data)); break
    case PeriodType.Month: part.appendChild(createMonthPeriodBlock(data)); break
    case PeriodType.Year: part.appendChild(createYearPeriodBlock(data))
  }

  part.appendChild(createDifferenceContainer(data))

  return part
}

export function createWeekPeriodBlock (data) {
  const container = document.createElement('div')
  container.style.paddingRight = '10px'

  const dateSpan = document.createElement('span')
  dateSpan.style.color = '#D3D5D9'
  const prevDateSpan = document.createElement('span')
  prevDateSpan.style.color = '#9B9B9B'

  const formattedDate = new Date(data.date).toLocaleDateString('ru', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  })

  const formattedPrevDate = new Date(data.prevDate).toLocaleDateString('ru', {
    day: 'numeric',
    month: 'short',
  })

  dateSpan.appendChild(document.createTextNode(formattedDate + ' / '))
  prevDateSpan.appendChild(document.createTextNode(formattedPrevDate))

  container.appendChild(dateSpan)
  container.appendChild(prevDateSpan)

  return container
}

export function createMonthPeriodBlock (data) {
  const container = document.createElement('div')
  container.style.paddingRight = '10px'

  const dateSpan = document.createElement('span')
  dateSpan.style.color = '#D3D5D9'
  const prevDateSpan = document.createElement('span')
  prevDateSpan.style.color = '#9B9B9B'

  const formattedDate = new Date(data.date).toLocaleDateString('ru', {
    day: 'numeric',
    month: 'short',
  })

  const formattedPrevDate = new Date(data.prevDate).toLocaleDateString('ru', {
    day: 'numeric',
    month: 'short',
  })

  dateSpan.appendChild(document.createTextNode(formattedDate + ' / '))
  prevDateSpan.appendChild(document.createTextNode(formattedPrevDate))

  container.appendChild(dateSpan)
  container.appendChild(prevDateSpan)

  return container
}

export function createYearPeriodBlock (data) {
  const container = document.createElement('div')
  container.style.paddingRight = '10px'

  const dateSpan = document.createElement('span')
  dateSpan.style.color = '#D3D5D9'
  const prevDateSpan = document.createElement('span')
  prevDateSpan.style.color = '#9B9B9B'

  const formattedDate = new Date(data.date).toLocaleDateString('ru', {
    day: 'numeric',
    month: 'numeric',
    year: '2-digit',
  })

  dateSpan.appendChild(document.createTextNode(formattedDate + ' / '))
  prevDateSpan.appendChild(document.createTextNode(new Date(data.prevDate).getFullYear().toString().slice(-2)))

  container.appendChild(dateSpan)
  container.appendChild(prevDateSpan)

  return container
}

export function createDifferenceContainer (data) {
  const container = document.createElement('div')
  container.style.display = 'flex'
  container.style.alignItems = 'center'
  container.style.fontSize = '18px'
  container.style.whiteSpace = 'nowrap'

  const differenceContainer = document.createElement('div')
  const difference = data.value - data.prevValue
  differenceContainer.appendChild(document.createTextNode(formatNumAsString(Math.abs(difference))))

  if (difference >= 0) {
    differenceContainer.style.color = '#6AAD00'
    container.appendChild(createArrowUpIcon())
  } else {
    differenceContainer.style.color = '#E92663'
    container.appendChild(createArrowDownIcon())
  }

  container.appendChild(differenceContainer)

  return container
}

export function createArrowUpIcon () {
  const icon = document.createElement('span')
  icon.classList.add('mdi', 'mdi-arrow-up')
  icon.style.marginRight = '5px'
  icon.style.color = '#6AAD00'

  return icon
}

export function createArrowDownIcon () {
  const icon = document.createElement('span')
  icon.classList.add('mdi', 'mdi-arrow-down')
  icon.style.marginRight = '5px'
  icon.style.color = '#E92663'

  return icon
}

export function createRightPart (data) {
  const part = document.createElement('div')
  part.style.padding = '5px 10px 5px 30px'

  const value = document.createElement('div')
  value.style.color = '#FF9D00'
  value.style.textAlign = 'right'
  value.style.fontSize = '16px'
  // value.style.paddingLeft = '30px'
  value.style.whiteSpace = 'nowrap'
  value.appendChild(document.createTextNode(formatNumAsString(data.value)))

  const prevValue = document.createElement('div')
  prevValue.style.color = '#D3D5D9'
  prevValue.style.textAlign = 'right'
  prevValue.style.fontSize = '16px'
  // prevValue.style.paddingLeft = '30px'
  prevValue.style.whiteSpace = 'nowrap'
  prevValue.appendChild(document.createTextNode(formatNumAsString(data.prevValue)))

  part.appendChild(value)
  part.appendChild(prevValue)

  return part
}
